import React, { useEffect } from 'react';
import { Box, Button, Heading, Text, VStack, Spinner } from '@chakra-ui/react';
import { useCurrentEvent } from '../context/CurrentEventContext';
import { useNavigate } from 'react-router-dom';

const MyEvents = () => {
  const { events, setCurrentEvent } = useCurrentEvent();
  const navigate = useNavigate();

  useEffect(() => {
    // Auto-select & redirect if only one event
    if (events.length === 1) {
      setCurrentEvent(events[0]);
      navigate('/designs');
    }
  }, [events, navigate, setCurrentEvent]);

  if (!events) {
    return (
      <Box py={20} textAlign="center">
        <Spinner />
      </Box>
    );
  }

  return (
    <Box maxW="lg" mx="auto" py={10} px={4} textAlign="center">
      <Heading size="lg" mb={8}>Select an Event</Heading>
      {events.length === 0 ? (
        <Text>No event registrations found for your account.</Text>
      ) : (
        <VStack spacing={4}>
          {events.map((evt) => (
            <Button
              key={evt.id}
              size="lg"
              width="100%"
              onClick={() => {
                setCurrentEvent(evt);
                navigate('/designs');
              }}
              colorScheme="blue"
              variant="outline"
            >
              {evt.name}
            </Button>
          ))}
        </VStack>
      )}
    </Box>
  );
};

export default MyEvents; 